/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {StatusBar} from './status-bar.model';

@Component({
    selector: 'app-status-bar',
    templateUrl: './status-bar.component.html',
    styleUrls: ['./status-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusBarComponent implements OnInit {

    /** Array of status to represent on the bar*/
    @Input() statusArray: StatusBar[];
    /** Variable to enabled or disable the bar */
    public emptyBar: boolean;
    /** Total of materials in the SPO */
    private totalMaterials: number;

    constructor() {
    }

    ngOnInit(): void {
        this.totalMaterials = this.getTotalMaterials(this.statusArray);
        this.emptyBar = (this.totalMaterials === 0);
    }

    /**
     * Returns the corresponding percentage of materials in a specific status
     * @param status The number os materials in a specific status
     * @param materialsTotal The total os materials
     */
    getStatusPercentage = (status: number, materialsTotal: number): number => ((status / materialsTotal) * 100);

    /**
     * Calculates the total of materials in a SPO
     * @param statusArray The status array to create the component from
     */
    getTotalMaterials = (statusArray: StatusBar[]): number => {
        let total = 0;
        if (statusArray && statusArray.length > 0) {

            const values = statusArray.map(state => state.value);
            total = values.reduce(this.add);
        }
        return total;
    };

    /**
     * Simple adding helper function
     * @param total Initial value
     * @param number Number to add
     */
    add = (total: number, number: number): number => total + number;

    getTooltipStrings(): string[] {
        const strings: string[] = [];
        this.statusArray.forEach(status => {
            strings.push(`${status.description} (${status.value})`);
        });
        return strings;
    }
}

